import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchExamByIdRequest,
  UpdateExamRequest,
  FetchExamsRequest,
  CreateExamRequest,
  DeleteExamRequest,
  EndExamRequest,
  UndoExamRequest,
  FetchAllExamsRequest,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Exam} from '../../../models'
import axios from 'axios'
import {
  fetchExamsUrl,
  fetchExamByIdUrl,
  createExamUrl,
  updateExamUrl,
  deleteExamUrl,
  endExamUrl,
  undoExamUrl,
  fetchAllExamsUrl,
} from '../../api'

export const fetchExams = createAsyncThunk(
  'exam/fetch',
  async (payload: FetchExamsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchExamsUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }&done=${payload.done}${payload.teachers ? '&teachers=' + payload.teachers : ''}${
          payload.classrooms ? '&classrooms=' + payload.classrooms : ''
        }${payload.students ? '&students=' + payload.students : ''}${
          payload.subjects ? '&subjects=' + payload.subjects : ''
        }&role=${payload.role}${payload.period ? '&period=' + payload.period : ''}`
      )
      const {exams, totalPages, total} = res.data
      return {
        exams,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllExams = createAsyncThunk(
  'exam/fetchAll',
  async (payload: FetchAllExamsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllExamsUrl}?done=${payload.done}${
          payload.teachers ? '&teachers=' + payload.teachers : ''
        }${payload.classrooms ? '&classrooms=' + payload.classrooms : ''}${
          payload.students ? '&students=' + payload.students : ''
        }${payload.subjects ? '&subjects=' + payload.subjects : ''}&role=${payload.role}${
          payload.period ? '&period=' + payload.period : ''
        }${payload.type ? '&type=' + payload.type : ''}`
      )
      const {exams} = res.data
      return {
        exams,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchExamById = createAsyncThunk(
  'exam/fetchById',
  async (payload: FetchExamByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchExamByIdUrl}/${payload.id}`)
      const {exam} = res.data
      return {
        exam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createExam = createAsyncThunk(
  'exam/create',
  async (payload: CreateExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createExamUrl, payload)
      const {exam} = res.data
      return {
        exam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateExam = createAsyncThunk(
  'exam/update',
  async (payload: UpdateExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateExamUrl, payload)
      const {exam} = res.data
      return {
        exam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteExam = createAsyncThunk(
  'exam/delete',
  async (payload: DeleteExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteExamUrl, payload)
      const {exam} = res.data
      return {
        exam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const endExam = createAsyncThunk(
  'exam/end',
  async (payload: EndExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(endExamUrl, payload)
      const {exam} = res.data
      return {
        exam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const undoExam = createAsyncThunk(
  'exam/undo',
  async (payload: UndoExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(undoExamUrl, payload)
      const {exam} = res.data
      return {
        exam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
